module.exports = __webpack_public_path__ + "17dcad47.svg";